module.exports = __webpack_public_path__ + "static/img/icon_gps.6f8e80df.png";